module.exports = __webpack_public_path__ + "img/nbus_box_object_3.7ac219d7.png";